// extracted by mini-css-extract-plugin
module.exports = {"container":"ClipBoard_container__3NeRz","msg":"ClipBoard_msg__w9l8w","bounce-in":"ClipBoard_bounce-in__2jJyT","icon":"ClipBoard_icon__BYxuw","input":"ClipBoard_input__1f4ae"};